import { SubmissionsScreen } from "@/features/submissions/SubmissionsScreen";

export default function SubmissionsTab() {
  return <SubmissionsScreen />;
}
